import Modal from "./Base/Modal";
import { FiX } from "react-icons/fi";
import React, { useState } from "react";
import InviteSuccessModal from "./InviteSuccessModal";
import { referral } from "../redux/referral/referralSlice";
import { useAppDispatch, useAppSelector } from "../redux/hooks";
import { useForm } from "react-hook-form";
import LoadingSpinner from "./LoadingSpinner";
import * as Yup from 'yup';
import {yupResolver} from "@hookform/resolvers/yup";
import ErrorViewer from "./ErrorViewer";
import Required from "./Required";

interface PropsI {
  showModal: boolean;
  onClose: () => void;
}

const TransactionSummaryModal = ({ showModal, onClose }: PropsI) => {
  const [showInviteSuccess, setShowInviteSuccessModal] = useState(false);
  const { isLoading, isSuccessful } = useAppSelector((state) => state?.referral);
  const dispatch = useAppDispatch();

  const toggleInviteSuccessModal = () =>
    setShowInviteSuccessModal(!showInviteSuccess);

  const validationSchema = Yup.object().shape({
    name: Yup.string().required("Name is required"),
    mobileNumber: Yup.string().required("Mobile number is required"),
    email: Yup.string().required("email is required").email("Invalid email format"),
  });

  const {
    handleSubmit, reset, register,
    formState: {errors},
  } = useForm({
    resolver: yupResolver(validationSchema),
    defaultValues: {
      name: "",
      mobileNumber: "",
      email: "",
    },
  });
  let referralName = "";

  const onSubmit = async (values: any, e: any) => {
    e.preventDefault();
    const referralAction = await dispatch(referral(values));
    if (referralAction?.type === "referral/fulfilled" && referralAction?.payload.statusCode === "00") {
      referralName = values.name
      toggleInviteSuccessModal();
    }
  };

  const closeAll = () => {
    toggleInviteSuccessModal();
    reset();
    onClose();
  };

  return (
    <>
      {!showInviteSuccess ? (
        <Modal
          showModal={showModal}
          onClose={onClose}
          className="transaction-summary-modal rounded-full"
        >
          <div className="modal-head rounded-t-xl">
            <div className="flex items-center">
              Invite a Friend, Get a Reward!
            </div>
            <button className="btn btn-text" onClick={onClose}>
              <FiX className="text-3xl" />
            </button>
          </div>
          <div className="modal-body rounded-b-xl">
            <div>
              Refer your friends to PenSmart and get paid for their
              transactions.
            </div>
            <div className="form__group">
              <label htmlFor="name" className="form__label">
                Name <Required />
              </label>
              <input
                id="name"
                type="text"
                className="form__input"
                {...register("name")}
              />
              {errors.name && (
                  <ErrorViewer message={errors.name.message as string} />
              )}
            </div>
            <div className="form__group">
              <label htmlFor="email" className="form__label">
                Email Address <Required />
              </label>
              <input
                id="email"
                type="email"
                className="form__input"
                {...register("email")}
              />
              {errors.email && (
                  <ErrorViewer message={errors.email.message as string} />
              )}
            </div>
            <div className="form__group">
              <label htmlFor="phoneNumber" className="form__label">
                Phone Number <Required />
              </label>
              <input
                id="phoneNumber"
                type="text"
                className="form__input"
                {...register("mobileNumber")}
              />
              {errors.mobileNumber && (
                  <ErrorViewer message={errors.mobileNumber.message as string} />
              )}
            </div>
            <div className="flex justify-end">
              <button className="btn btn-text mr-6" onClick={onClose} disabled={isLoading}>
                Cancel
              </button>
              <button
                className="btn btn-primary"
                onClick={handleSubmit(onSubmit)}
              >
                {isLoading ? <LoadingSpinner /> : "Send Invite"}
              </button>
            </div>
          </div>
        </Modal>
      ) : (
        <InviteSuccessModal
          name={referralName}
          showModal={true}
          onClose={closeAll}
          onBack={()=>{
            reset();
            toggleInviteSuccessModal();
          }}
        />
      )}
    </>
  );
};

export default TransactionSummaryModal;
